var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHeaderDown = function SvgIconHeaderDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M3.195 5.5c.26-.26.683-.26.943 0L8 9.362 11.862 5.5a.667.667 0 1 1 .943.943l-3.862 3.862c-.52.52-1.365.52-1.886 0L3.195 6.443a.667.667 0 0 1 0-.943",
    clipRule: "evenodd"
  })));
};
export default SvgIconHeaderDown;